import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'
import { useTransfersPeriodicStore } from '@/store/transfers/transfersPeriodic'

const periodicRouteNames = new Set([
	routeList.TRANSFERS_PERIODIC_NAME,
	routeList.TRANSFERS_PERIODIC_SAMEBANK_NAME,
	routeList.TRANSFERS_PERIODIC_OTHERBANK_NAME,
	routeList.TRANSFERS_PERIODIC_EDIT_NAME
])

const periodicConsultBeforeEnter = (to, from, next) => {
	if (!periodicRouteNames.has(from.name)) {
		useTransfersPeriodicStore().saveSelectedPeriodicAccountId(null)
	}
	next()
}

export default [{
	path: routeList.TRANSFERS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.TRANSFERS_NACIONAL_PATH,
	name: routeList.TRANSFERS_NACIONAL_NAME,
	props: true,
	component: () => import('@/views/transfers/Nacional')
}, {
	path: routeList.TRANSFERS_INTERNATIONAL_PATH,
	name: routeList.TRANSFERS_INTERNATIONAL_NAME,
	props: true,
	component: () => import('@/views/transfers/International')
}, {
	path: routeList.TRANSFERS_INSTANT_BAI_PATH,
	name: routeList.TRANSFERS_INSTANT_BAI_NAME,
	props: true,
	component: () => import('@/views/transfers/InstantBAI')
},
/* ***********************************************
*                        KWIK                    *
*********************************************** */
{
	path: routeList.TRANSFERS_KWIK_PATH,
	name: routeList.TRANSFERS_KWIK_NAME,
	component: () => import('@/views/ThirdLevelMenu')
},
{
	path: routeList.TRANSFERS_KWIK_TRANSFER_PATH,
	name: routeList.TRANSFERS_KWIK_TRANSFER_NAME,
	component: () => import('@/views/transfers/kwik/Transfer')
},
{
	path: routeList.TRANSFERS_KWIK_MANAGE_ACCOUNTS_PATH,
	name: routeList.TRANSFERS_KWIK_MANAGE_ACCOUNTS_NAME,
	component: () => import('@/views/transfers/kwik/AccountManagement')
},
/* ********************************************* */
{
	path: routeList.TRANSFERS_REQUEST_NAHORA_PATH,
	name: routeList.TRANSFERS_REQUEST_NAHORA_NAME,
	component: () => import('@/views/UnderDevelopment')
},
/* ***********************************************
*                      HISTORY                   *
*********************************************** */
{
	path: routeList.TRANSFERS_HISTORY_PATH,
	name: routeList.TRANSFERS_HISTORY_NAME,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.TRANSFERS_HISTORY_INTERNATIONAL_PATH,
	name: routeList.TRANSFERS_HISTORY_INTERNATIONAL_NAME,
	component: () => import('@/views/transfers/history/International')
}, {
	path: routeList.TRANSFERS_HISTORY_NACIONAL_PATH,
	name: routeList.TRANSFERS_HISTORY_NACIONAL_NAME,
	component: () => import('@/views/transfers/history/National')
},
/* ***********************************************
*                     PERIODIC                   *
*********************************************** */
{
	path: routeList.TRANSFERS_PERIODIC_PATH,
	name: routeList.TRANSFERS_PERIODIC_NAME,
	component: () => import('@/views/transfers/periodic/consult/Samebank'),
	beforeEnter: periodicConsultBeforeEnter
}, {
	path: routeList.TRANSFERS_PERIODIC_SAMEBANK_PATH,
	name: routeList.TRANSFERS_PERIODIC_SAMEBANK_NAME,
	component: () => import('@/views/transfers/periodic/consult/Samebank'),
	beforeEnter: periodicConsultBeforeEnter
}, {
	path: routeList.TRANSFERS_PERIODIC_OTHERBANK_PATH,
	name: routeList.TRANSFERS_PERIODIC_OTHERBANK_NAME,
	component: () => import('@/views/transfers/periodic/consult/Otherbanks'),
	beforeEnter: periodicConsultBeforeEnter
}, {
	path: routeList.TRANSFERS_PERIODIC_EDIT_PATH,
	name: routeList.TRANSFERS_PERIODIC_EDIT_NAME,
	props: true,
	component: () => import('@/views/transfers/periodic/Edit'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.TRANSFERS_PERIODIC_NAME)
	}
},
/* ***********************************************
*                  BENEFICIARIES                 *
*********************************************** */
{
	path: routeList.TRANSFERS_BENEFICIARIES_PATH,
	name: routeList.TRANSFERS_BENEFICIARIES_NAME,
	component: () => import('@/views/transfers/beneficiaries/Consult')
},
{
	path: routeList.TRANSFERS_BENEFICIARIES_CREATE_PATH,
	name: routeList.TRANSFERS_BENEFICIARIES_CREATE_NAME,
	component: () => import('@/views/transfers/beneficiaries/Create')
},
{
	path: routeList.TRANSFERS_BENEFICIARIES_EDIT_PATH,
	name: routeList.TRANSFERS_BENEFICIARIES_EDIT_NAME,
	props: true,
	component: () => import('@/views/transfers/beneficiaries/Edit'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.TRANSFERS_BENEFICIARIES_NAME)
	}
},
/* ***********************************************
*                     REQUESTS                   *
*********************************************** */
{
	path: routeList.TRANSFERS_REQUESTS_PATH,
	name: routeList.TRANSFERS_REQUESTS_NAME,
	component: () => import('@/views/ThirdLevelMenu')
}, {
	path: routeList.TRANSFERS_REQUESTS_INTERNATIONAL_PATH,
	name: routeList.TRANSFERS_REQUESTS_INTERNATIONAL_NAME,
	component: () => import('@/views/transfers/requests/International')
}, {
	path: routeList.TRANSFERS_REQUESTS_INTERNATIONAL_CORPORATE_PATH,
	name: routeList.TRANSFERS_REQUESTS_INTERNATIONAL_CORPORATE_NAME,
	component: () => import('@/views/transfers/requests/InternationalCorporate')
},
{
	path: routeList.TRANSFERS_REQUESTS_NACIONAL_PATH,
	name: routeList.TRANSFERS_REQUESTS_NACIONAL_NAME,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.TRANSFERS_REQUESTS_NACIONAL_NAHORA_SENT_PATH,
	name: routeList.TRANSFERS_REQUESTS_NACIONAL_NAHORA_SENT_NAME,
	component: () => import('@/views/transfers/requests/nacional/NaHoraReceived')
}, {
	path: routeList.TRANSFERS_REQUESTS_NACIONAL_NAHORA_RECEIVED_PATH,
	name: routeList.TRANSFERS_REQUESTS_NACIONAL_NAHORA_RECEIVED_NAME,
	component: () => import('@/views/transfers/requests/nacional/NaHoraSent')
}]
